import type { schemaType as cottagesHomeBestType } from '~~/shared/api/rurality/v3/cottages/home/best/schema'
import type { schemaType as cottagesListType } from '~~/shared/api/rurality/v3/cottages/list/schema'
import type { propsInterface } from '~~/modules/design-system/sections/s-cards-rated/index.vue'

export const useToSCardsRated = () => {
  const fromCottagesHomeBest = (data: cottagesHomeBestType): propsInterface => {
    const MAX_CHARACTERS = 200

    let items: propsInterface['items'] = []

    items = data.cottages.map(item => {
      return {
        url: item.url,
        src: item.media.url,
        name: item.name,
        description: cropText(item.description, MAX_CHARACTERS),
        price: toEuro(item.averagePriceAmount.amount),
        subtitle: item.province.name,
        comments: item.reviews.total,
        rate: item.reviews.average,
        priceText: t('landings.home.best-cottages.card-price-average-text'),
        buttonText: t('landings.home.best-cottages.card-button'),
      }
    })

    return { items }
  }

  const fromCottagesListHomeFeatured = (
    data: cottagesListType,
  ): propsInterface => {
    const MAX_CHARACTERS = 200

    let items: propsInterface['items'] = []

    items = data.cottages.map(item => {
      return {
        url: item.url,
        src: item.media.url,
        name: item.name,
        description: cropText(item.description, MAX_CHARACTERS),
        price: toEuro(item.averagePrice),
        subtitle: item.province.name,
        comments: item.reviews.total,
        rate: item.reviews.average,
        priceText: t('landings.home.best-cottages.card-price-average-text'),
        buttonText: t('landings.home.best-cottages.card-button'),
      }
    })

    return { items }
  }

  return { fromCottagesHomeBest, fromCottagesListHomeFeatured }
}
